import { BBoxArray } from './bboxTypes'

export const bboxOverlap = (
  [leftA, bottomA, rightA, topA]: BBoxArray,
  [leftB, bottomB, rightB, topB]: BBoxArray
) => !(rightA < leftB || rightB < leftA || topA < bottomB || topB < bottomA)
